import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guides";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/")({
  head: SEO["/guides"],
  component: () => <ContentPage path="/guides" body={body} />,
});
